import { put, select } from 'typed-redux-saga'
import { AnyAction } from 'redux-saga'

import { ApplicationState } from '@store/types'

import captureDocumentsSaga from './captureDocumentsSaga'
import signatureDocumentsSaga from './signatureDocumentsSaga'
import { buscarDocumentos, hideLoading, setEtapaBusca, showLoading } from '../actions'

interface Props {
  callback?: () => void
  callbackError?: () => void
  type: string
}

const callbackError = (payload: Props) => ({
  message: 'Aguarde um instante e tente novamente.',
  actionCallback: () => buscarDocumentos(payload),
  actionTitle: 'Tentar Novamente',
})

export default function* buscarDocumentosSaga(action: AnyAction) {
  const payload = action.payload as Props
  const { etapaBusca } = yield* select(
    (state: ApplicationState) => state.refinanciamento.documentos,
  )
  const STEP_CAPTURE = 1
  const STEP_DOCS = 2
  try {
    yield put(showLoading())
    let success = true
    if (!etapaBusca || etapaBusca <= STEP_CAPTURE) {
      yield put(setEtapaBusca(STEP_CAPTURE))
      success = yield* captureDocumentsSaga({
        noRemoveLoader: true,
        actionCallbackError: callbackError(payload),
        type: '',
      })
    }
    if (success && etapaBusca <= STEP_DOCS) {
      yield put(setEtapaBusca(STEP_DOCS))
      success = yield* signatureDocumentsSaga({
        noRemoveLoader: true,
        actionCallbackError: callbackError(payload),
        type: '',
      })
    }
    if (success) {
      yield put(hideLoading())
      if (payload.callback) {
        yield payload.callback()
        return true
      }
      return true
    }
    yield put(hideLoading())
    return false
  } catch (error) {
    yield put(hideLoading())
    if (payload.callbackError) {
      yield payload.callbackError()
    }
    return false
  }
}
